module.exports = __webpack_public_path__ + "img/pc-th.1b589fd6.jpg";